import * as a from "react";
import t from "../lib/IconBase.es.js";
import s from "../defs/ChatTeardropSlash.es.js";
const o = a.forwardRef((r, e) => /* @__PURE__ */ a.createElement(t, { ref: e, ...r, weights: s }));
o.displayName = "ChatTeardropSlashIcon";
const c = o;
export {
  c as ChatTeardropSlash,
  o as ChatTeardropSlashIcon
};
